import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSettingsState } from '@/components/context/SettingsContext';

export default function RecommendationRegistrationButton({ recommendation }) {
  const { shortPhoneNumber } = useSettingsState();
  const phoneNumber = shortPhoneNumber || '1811';
  const canRegister = recommendation.canRegisterOnline && recommendation.serviceId
    && recommendation.categoryId && recommendation.serviceTypeId;

  return canRegister ? (
    <Button asChild variant="light" className="sm:w-32 border border-primary" onClick={(event) => event.stopPropagation()}>
      <Link to={`/services/${recommendation.categoryId}/${recommendation.serviceTypeId}?serviceId=${recommendation.serviceId}`}>
        Registruotis
      </Link>
    </Button>
  ) : (
    <Button asChild variant="light" className="sm:w-32 gap-1 border border-[#04B64F] has-[>svg]:px-2" onClick={(event) => event.stopPropagation()}>
      <a href={`tel:${phoneNumber}`}><Phone aria-hidden="true" />Skambinti {phoneNumber}</a>
    </Button>
  );
}
